import { UserQueryQuery } from "gql-gen";

type SettingsUser = NonNullable<UserQueryQuery["me"]>;

export function isProfileMissingInfo(user: SettingsUser): boolean {
  return !(
    user.firstName &&
    user.lastName &&
    user.language &&
    user.assets?.find((a: any) => a.assetType === "profile_image")
  );
}

export function isLocationMissingInfo(user: SettingsUser) {
  return !!user.profile?.address ? !user.profile?.shipHome && !user.profile?.shippingAddress : true;
}
